import { render } from "./InventoryItemTypeSelector.vue?vue&type=template&id=f4e532c0"
import script from "./InventoryItemTypeSelector.vue?vue&type=script&lang=js"
export * from "./InventoryItemTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__